import React from 'react';
import PropTypes from 'prop-types';
import { DateObject } from 'react-multi-date-picker';
import { useTranslation } from 'react-i18next';
import UiButton from 'ui-components/ui-button/UiButton';

/**
 * کامپوننت مربوط به قسمت اعمال تاریخ
 * @returns
 */
export function RangePickerFooter(props) {
  const { fromTime, toTime, values = [], onDateTimeApply } = props;
  const { t } = useTranslation();
  return (
    <div className='range-picker-footer flex end p-15 rtl between pt-20'>
      <div>
        {new DateObject(values[0]).format('DD MMMM')} {t('common:time')}{' '}
        {new DateObject(fromTime).format('HH:mm')}
        {values[1] && (
          <>
            <span className='mlr-10'>{t('common:to')}</span>
            {new DateObject(values[1]).format('DD MMMM')} {t('common:time')}{' '}
            {new DateObject(toTime).format('HH:mm')}
          </>
        )}
      </div>
      <UiButton
        onClick={onDateTimeApply}
        data-testid={`${props?.['data-testid']}-submit`}
      >
        {t('common:confirm')}
      </UiButton>
    </div>
  );
}

RangePickerFooter.propTypes = {
  fromTime: PropTypes.object,
  toTime: PropTypes.object,
  values: PropTypes.array,
  onDateTimeApply: PropTypes.func,
  'data-testid': PropTypes.string,
};
